module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.ttf
// module id = 379
// module chunks = 0